import type { PayloadWithoutId } from '@components/ArtBoard/Comments/types'
import { useState } from 'react'

export const useCommitState = (
  onCommit: (payload: PayloadWithoutId) => Promise<void>
) => {
  const [state, setState] = useState<'idle' | 'loading' | 'error'>('idle')

  const handleCommit = async (content: string) => {
    setState('loading')

    try {
      await onCommit({ content, recipients: [] })

      setState('idle')
    } catch {
      setState('error')
    }
  }

  const error = state === 'error'
  const loading = state === 'loading'

  return { handleCommit, error, loading }
}
